(function(){
'use strict';
function init(root){
  if(root.dataset.ready==='1')return;
  root.dataset.ready='1';
  var hi=root.dataset.locale==='hi';
  var search=root.querySelector('[data-sp-sacred-search]');
  var clear=root.querySelector('[data-sp-sacred-clear]');
  var reset=root.querySelector('[data-sp-sacred-reset]');
  var result=root.querySelector('[data-sp-sacred-result]');
  var empty=root.querySelector('[data-sp-sacred-empty]');
  var cards=Array.from(root.querySelectorAll('[data-sp-sacred-card]')).sort(function(a,b){return Number(a.dataset.displayOrder||999)-Number(b.dataset.displayOrder||999);});
  var grid=root.querySelector('[data-sp-sacred-grid]');
  cards.forEach(function(card){grid.appendChild(card);});
  var filters=Array.from(root.querySelectorAll('[data-sp-category]'));
  var counts={all:cards.length},selected='all';
  cards.forEach(function(c){
    var key=c.dataset.category||'';
    counts[key]=(counts[key]||0)+1;
    c.dataset.search=(c.dataset.keywords||'').toLocaleLowerCase();
  });
  root.querySelectorAll('[data-sp-filter-count]').forEach(function(s){s.textContent='('+(counts[s.dataset.spFilterCount]||0)+')';});
  function update(){
    var term=search.value.trim().toLocaleLowerCase().replace(/\s+/g,' '),shown=0;
    cards.forEach(function(c){
      var match=(selected==='all'||c.dataset.category===selected)&&(!term||c.dataset.search.indexOf(term)!==-1);
      c.hidden=!match;if(match)shown++;
    });
    filters.forEach(function(b){b.setAttribute('aria-pressed',b.dataset.spCategory===selected?'true':'false');});
    result.textContent=hi?'कुल '+cards.length+' में से '+shown+' गाइड':'Showing '+shown+' of '+cards.length+' guides';
    empty.hidden=shown!==0;clear.hidden=!term;
  }
  search.addEventListener('input',update);
  clear.addEventListener('click',function(){search.value='';update();search.focus();});
  reset.addEventListener('click',function(){selected='all';search.value='';update();search.focus();});
  filters.forEach(function(b){b.addEventListener('click',function(){selected=b.dataset.spCategory;update();});});
  update();
}
function boot(){document.querySelectorAll('[data-sp-sacred-archive]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
})();